import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu, MenuTrigger, Popover } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
/**
 * A menu displays a list of actions or options that a user can choose.
 */
export function ActionMenu({ triggerElement, ...props }) {
    return (_jsxs(MenuTrigger, { ...props, children: [triggerElement, _jsx(Popover, { offset: 4, className: "entering:animate-in entering:fade-in exiting:animate-out exiting:fade-out", children: _jsx(Menu, { ...props, className: twMerge('flex flex-col rounded border border-default bg-default py-1 shadow-lg outline-none', props.className) }) })] }));
}
//# sourceMappingURL=ActionMenu.js.map